import { FC, useState, useRef, useLayoutEffect } from "react";
import { NavLink } from "react-router-dom";
import { Switch } from "@headlessui/react";
import { useRouteMatch } from "react-router";

export interface CommonLayoutProps {
  match?: any;
}

interface IProfile {
  path: string;
  title: string;
}

const userDashboard: IProfile[] = [
  {
    path: "/account",
    title: "Informasi Akun",
  },
  {
    path: "/account-address",
    title: "Alamat Tersimpan",
  },
  // {
  //   path: "/account-verification",
  //   title: "Verifikasi Identitas",
  // },
  // {
  //   path: "/account-entries",
  //   title: "Pesanan Anda",
  // },
  {
    path: "/account-savelists",
    title: "Daftar Kesukaan",
  },
  {
    path: "/account-password",
    title: "Settings",
  },
];

const vendorDashboard: IProfile[] = [
  {
    path: "/vendor-status",
    title: "Status Toko",
  },
  {
    path: "/vendor-listing",
    title: "Listing Produk",
  },
  // {
  //   path: "/vendor-entries",
  //   title: "Pesanan Masuk",
  // },
];

const CommonLayout: FC<CommonLayoutProps> = ({ children, match }) => {
  const [vendor, setVendor] = useState<boolean>(false);

  const vendorz = useRef(false);
  const url = useRouteMatch();

  useLayoutEffect(() => {
    if (
      ["/vendor-status", "/vendor-listing", "/vendor-entries"].includes(
        url.path
      )
    ) {
      setVendor(true);
    } else {
      setVendor(false);
    }
  }, [vendorz]);

  return (
    <div className="nc-CommonLayoutProps bg-neutral-50 dark:bg-neutral-900">
      <div className="border-b border-neutral-200 dark:border-neutral-700 pt-12 bg-white dark:bg-neutral-900">
        <div className="container">
          <div className="flex items-center w-max">
            <label
              className={`text-xl font-semibold text-primary-6000 ${
                vendor && "opacity-30"
              } w-min`}
            >
              Renter
            </label>
            <Switch
              checked={vendor}
              onChange={setVendor}
              className={`${
                vendor ? "bg-primary-6000 " : "bg-primary-6000 "
              } relative inline-flex items-center h-6 rounded-full w-11 mx-5`}
            >
              <span className="sr-only">Enable notifications</span>
              <span
                className={`${
                  vendor ? "translate-x-6" : "translate-x-1"
                } inline-block w-4 h-4 transform bg-white rounded-full`}
              />
            </Switch>
            <label
              className={`text-xl font-semibold text-primary-6000 ${
                vendor || "opacity-30"
              } w-min`}
            >
              Vendor
            </label>
          </div>
          <hr className="mt-5 w-1/2" />
          {!!vendor ? (
            <div className="flex space-x-8 md:space-x-14 overflow-x-auto hiddenScrollbar">
              {vendorDashboard.map((item) => {
                return (
                  <NavLink
                    key={item.path}
                    activeClassName="!border-primary-500"
                    to={item.path}
                    className="block py-5 md:py-8 border-b-2 border-transparent flex-shrink-0"
                  >
                    {item.title}
                  </NavLink>
                );
              })}
            </div>
          ) : (
            <div className="flex space-x-8 md:space-x-14 overflow-x-auto hiddenScrollbar">
              {userDashboard.map((item) => {
                return (
                  <NavLink
                    key={item.path}
                    activeClassName="!border-primary-500"
                    to={item.path}
                    className="block py-5 md:py-8 border-b-2 border-transparent flex-shrink-0"
                  >
                    {item.title}
                  </NavLink>
                );
              })}
            </div>
          )}
        </div>
      </div>
      <div className="container pt-14 sm:pt-20 pb-24 lg:pb-32">{children}</div>
    </div>
  );
};

export default CommonLayout;
